// extracted by mini-css-extract-plugin
export default {"fs":"_93cb532a9e _557b640163"};